import { Check, Lock } from "lucide-react";
import { breakProps } from "@/lib/theme";

export const SceneBreakSample = ({ d }) => {
  const p = breakProps(d);
  return (
    <div {...p} className="sb-mini" data-testid={`scene-break-sample-${d.id}`}>
      <div className="writing-prose"><hr /></div>
    </div>
  );
};

export const SceneBreakCard = ({ d, active, locked, onClick }) => (
  <button onClick={onClick} className={`text-left rounded-2xl border p-3 transition-colors ${active ? "border-amber-500 bg-amber-500/5" : "border-line hover:border-amber-500/40 bg-panel"}`}
    data-testid={`scene-break-card-${d.id}`}>
    <div className="rounded-xl bg-inset px-4 py-2"><SceneBreakSample d={d} /></div>
    <div className="flex items-center gap-2 pt-2 px-1">
      <span className="text-sm text-slate-200 truncate flex-1">{d.name}</span>
      {active && <Check className="w-4 h-4 text-amber-400 shrink-0" data-testid={`scene-break-active-${d.id}`} />}
      {locked && <Lock className="w-3.5 h-3.5 text-slate-500 shrink-0" />}
    </div>
  </button>
);
